import { PromotionalMessagesUI } from "./PromotionalMessagesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { promotionalMessagesToShow } from "./promotionalMessagesUtils";
import { VariantGroup } from "../../types/types";
import { hasAnyStock } from "../../utils/product/hasAnyStock";

//TODO This is duplicated in PreOrderMessage and PriceAndReviews. Share? Is this function understandable, or must we use colour somehow?
function getColourGroupForVariant(
  variantGroups: VariantGroup[],
  variantId: string,
) {
  return variantGroups?.find((group) =>
    group.variants.some((v) => v.id === variantId),
  );
}

export function PromotionalMessages({
  product,
  configProps,
  experiences,
}: Pick<StandardProps, "product" | "configProps" | "experiences">) {
  const { variant, isSelected } = useVariant(product);
  const { newPromoListItem, newPromoDrawer } = experiences;
  const {
    saveLabels,
    promoTimerVariant,
    countdownEndYear,
    countdownEndMonth,
    countdownEndDay,
  } = experiences;

  const messages = promotionalMessagesToShow(
    product,
    variant,
    isSelected,
    saveLabels === "on",
    configProps?.useVariantGroups && product.variantGroups
      ? getColourGroupForVariant(product.variantGroups, variant.id)
      : undefined,
  );

  const hidePromoDrawer =
    typeof configProps?.hidePromoDrawer == "boolean"
      ? configProps.hidePromoDrawer
      : false;

  let countdownTimerAvailabileToOrder = false;

  if (promoTimerVariant !== "C") {
    const isFullyOutOfStock =
      !hasAnyStock(product) &&
      product.__typename === "SimpleProduct" &&
      product.variants?.length === 1;

    if (!isSelected) {
      countdownTimerAvailabileToOrder = !isFullyOutOfStock;
    } else {
      countdownTimerAvailabileToOrder =
        variant.availability?.availableToOrder || false;
    }
  }

  const countdownTimerEnd = {
    year: countdownEndYear as number,
    month: countdownEndMonth as number,
    day: countdownEndDay as number,
  };

  return (
    <PromotionalMessagesUI
      promotionalMessages={messages}
      hidePromoDrawer={hidePromoDrawer}
      isNewPromoTags={newPromoListItem === "on" || newPromoDrawer === "on"}
      showPromoTimerVariant={promoTimerVariant as string}
      countdownTimerAvailabileToOrder={countdownTimerAvailabileToOrder}
      countdownTimerEnd={countdownTimerEnd}
    />
  );
}
